var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTop100(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_192_1367)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M0.733398 23.2712V11.0122L5.27327 7.39048V23.2707L0.733398 23.2712ZM12.9948 6.94482C8.97886 6.94482 5.71925 10.7025 5.71925 15.3306C5.71967 19.9599 8.97928 23.7164 12.9948 23.7164C17.0104 23.7164 20.27 19.9595 20.27 15.3306C20.27 10.7025 17.0104 6.94482 12.9948 6.94482ZM12.9948 19.6302C11.2294 19.6302 9.81314 17.6936 9.81314 15.3118C9.81314 12.9295 11.2294 10.9929 12.9948 10.9929C14.7602 10.9929 16.1765 12.9295 16.1765 15.3114C16.1765 17.6936 14.7602 19.6302 12.9948 19.6302ZM28.0105 6.94482C23.995 6.94482 20.7358 10.7025 20.7358 15.3306C20.7354 19.9599 23.9945 23.7164 28.0105 23.7164C32.0269 23.7164 35.2667 19.9595 35.2667 15.3306C35.2667 10.7025 32.0071 6.94482 28.0105 6.94482ZM28.0105 19.6302C26.2455 19.6302 24.8292 17.6936 24.8292 15.3118C24.8292 12.9295 26.2455 10.9929 28.0109 10.9929C29.7764 10.9929 31.1926 12.9295 31.1926 15.3114C31.1926 17.6936 29.7566 19.6298 28.0109 19.6298L28.0105 19.6302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2084 0.592773H11.7723V5.70542H13.2084V0.592773ZM3.857 4.21448L2.26636 5.57026V0.592773H3.857V4.21448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2837 0.592773H12.102V1.94856H15.2837V0.592773ZM5.27327 0.592773H0.733398V1.83223H5.27327V0.592773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4287 0.592858H14.8768V5.70551H16.4287V0.592858ZM8.41574 0.283203C6.86385 0.283203 5.60254 1.54191 5.60254 3.09102C5.60254 4.64055 6.86385 5.89967 8.41574 5.89967C9.96806 5.89967 11.2289 4.64055 11.2289 3.09144C11.2289 1.54191 9.96806 0.283203 8.41574 0.283203ZM8.41574 4.54389C7.65938 4.54389 7.05799 3.88524 7.05799 3.09144C7.05799 2.29721 7.65938 1.63899 8.41574 1.63899C9.17253 1.63899 9.77391 2.29721 9.77391 3.09102C9.77391 3.88524 9.17253 4.54389 8.41574 4.54389Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_192_1367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.5333,
    height: 23.4333,
    fill: "white",
    transform: "translate(0.733398 0.283203)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop100);
export default __webpack_public_path__ + "static/media/top100.2e2e003563ce1c46f09d6cd3135bf591.svg";
export { ForwardRef as ReactComponent };